import getLocal from '@/app/utils/getLocal';
import { shopifyProductVariantSelectById } from 'lowcode/apis/getShopifyProductList';
import GloLayout from 'lowcode/common/GloLayout';
import { BaseCardBtnText } from 'lowcode/common/LangText/BaseCardBtnText';
import MemberCardItem from 'lowcode/common/MemberCommon/member-card/MemberCardItem';
import IconMore from 'lowcode/common/MemberCommon/member-card/MemberCardItem/comps/IconMore';
import { Fragment, useEffect, useState } from 'react';
import './index.scss';
// 获取变体ID
const getVariantIdHandle = (list: any) => {
    const idArr1 = list.map((item: any) => {
        return item.variantId;
    });
    const idArr2 = list.map((item: any) => {
        return item.priceVariantId;
    });
    const idArr3 = list.map((item: any) => {
        return item.compareAtPriceVariantId;
    });
    const idArr4 = list.map((item: any) => {
        return item.memberVariantId;
    });
    const idArray1 = [...idArr1, ...idArr2, ...idArr3, ...idArr4];
    const idArray2 = idArray1.filter((item: any) => {
        return item;
    });
    const idArray3 = Array.from(new Set(idArray2));
    return idArray3;
};
export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { locale = 'us' } = getLocal();
    const { list = [], cardBgColor, title, titleColor, subTitle, subTitleColor } = data;
    const [items, setItems] = useState(list);
    const styleComp: any = {
        '--member-h-titleColor': titleColor,
        '--member-h-subTitleColor': subTitleColor,
    };
    const cardType = 'oneLine';
    const totalLength = list.length;
    const [showMore, setShowMore] = useState(false); // 更多
    const TextA = BaseCardBtnText[locale] || BaseCardBtnText['us'];
    // 更多
    const moreHandle = () => {
        const showMore2 = !showMore;
        setShowMore(showMore2);
    };
    useEffect(() => {
        if (isEditStatus) {
            setItems(list || []);
        }
    }, [data]);
    useEffect(() => {
        const idArray = getVariantIdHandle(list);
        const initDataHandle = async () => {
            const productList1 = await shopifyProductVariantSelectById(locale, idArray);
            // 从 array 变成针对 variantId 的 object
            const productObject: any = {};
            productList1.forEach((item: any) => {
                productObject[item.variantId] = item;
            });
            const items2 = JSON.parse(JSON.stringify(items));
            items2.forEach((item: any) => {
                // 主产品信息
                const variantId = item.variantId;
                const itemA1 = productObject[variantId];
                if (variantId && itemA1) {
                    item.productId = itemA1.productId; // 必须将产品id同步过来，因为加购物车时需要请求判断是否有优惠券或者礼品卡，该接口后端必须传参产品id
                    item.shopifyTitle = itemA1.title;
                    item.inventory = itemA1.inventoryQuantity;
                    item.shopifyPc = itemA1.imageUrl || itemA1.img || item.shopifyPc;
                }
                // 售价
                const priceVariantId = item.priceVariantId;
                const itemA2 = productObject[priceVariantId];
                if (priceVariantId && itemA2) {
                    item.shopifyPricePrice = itemA2.price;
                    item.shopifyPriceCompareAtPrice = itemA2.compareAtPrice;
                }
                // 划线价
                const compareAtPriceVariantId = item.compareAtPriceVariantId;
                const itemA3 = productObject[compareAtPriceVariantId];
                if (compareAtPriceVariantId && itemA3) {
                    item.shopifyCompareAtPricePrice = itemA3.price;
                    item.shopifyCompareAtPriceCompareAtPrice = itemA3.compareAtPrice;
                }
                // 会员价
                const memberVariantId = item.memberVariantId;
                const itemA4 = productObject[memberVariantId];
                if (memberVariantId && itemA4) {
                    item.shopifyMemberPrice = itemA4.price;
                    item.shopifyMemberCompareAtPrice = itemA4.compareAtPrice;
                }
            });
            setItems(items2);
        };
        initDataHandle();
    }, []);
    return (
        <GloLayout id={id} className={`temp-member-product-scene temp-member-product-scene-${cardType} temp-hide`}>
            <div className={`temp-member-product-scene-h ef-content ${title || subTitle ? '' : ' temp-member-product-scene-h-hide'}`} style={styleComp}>
                <div className="temp-member-product-scene-h-title">{title}</div>
                <div className="temp-member-product-scene-h-subTitle">{subTitle}</div>
            </div>
            <div className={`temp-member-product-scene-in${showMore ? ' temp-member-product-scene-in-show-more' : ''}`}>
                {items.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <MemberCardItem item={item} cardType={cardType} cardBgColor={cardBgColor} isEditStatus={isEditStatus} />
                        </Fragment>
                    );
                })}
            </div>
            {totalLength > 6 && (
                <div className="temp-member-product-scene-btn-box">
                    <div className="temp-member-product-scene-btn" onClick={moreHandle}>
                        {showMore ? TextA.ViewLess : TextA.ViewMore}
                        <IconMore />
                    </div>
                </div>
            )}
        </GloLayout>
    );
}
